import { TooltipWrapper } from '@va/ui/tooltips';
import classNames from 'classnames';
import { PropsWithChildren } from 'react';

type PageUrlActionProps = {
  className?: string;
  onClick: () => void;
  tooltip?: string;
  disabled?: boolean;
};

export const PageUrlAction = ({
  onClick,
  className,
  tooltip,
  children,
  disabled,
}: PropsWithChildren<PageUrlActionProps>) => {
  return (
    <TooltipWrapper content={tooltip}>
      <button
        className={classNames(
          'bg-black-lighter-84 text-white-75 p-3 flex items-center justify-center min-w-12 min-h-12 shrink-0 grow backdrop-blur-xs',
          className,
        )}
        onClick={onClick}
        disabled={disabled}
      >
        {children}
      </button>
    </TooltipWrapper>
  );
};
